import { render, staticRenderFns } from "./pantalla3-1.vue?vue&type=template&id=7c8e805f&scoped=true&"
var script = {}
import style0 from "./pantalla3-1.vue?vue&type=style&index=0&id=7c8e805f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e805f",
  null
  
)

export default component.exports